import { IconButton as MuiIconButton } from '@mui/material';
import { Tooltip } from 'sharedComponents/Tooltip';
import { TooltipIconButtonProps } from './types';

export const TooltipIconButton: React.FC<TooltipIconButtonProps> = ({
  children,
  sx,
  tooltipTitle,
  onClick,
  placement,
  dataTestId,
  size,
}) => {
  return (
    <Tooltip title={tooltipTitle} placement={placement}>
      <MuiIconButton
        size={size}
        aria-label={tooltipTitle}
        sx={sx}
        onClick={onClick}
        data-testid={dataTestId}
      >
        {children}
      </MuiIconButton>
    </Tooltip>
  );
};
